// extracted by mini-css-extract-plugin
export default {"header":"DashboardHeader_header__iw4m2"};